import React from "react";
import { Button, Card, Col, Container, Row } from "reactstrap";
import {
  Mic,
  Users,
  Award,
  Handshake,
  Calendar,
  Monitor,
  Map,
  Building2,
  Briefcase,
  Home,
  Settings,
  Database,
  Box,
  Cpu,
  Landmark,
  Wrench,
  Navigation,
  HardHat,
  Code,
} from "lucide-react";

function Attend() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        style={{
          background: "transparent",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
        <div className="filter" />
        <Container className={""}>
          <Row className="justify-content-center">
            {/* <Col md="12">
              <div className="mb-5">
                <h1
                  className="text-center text-g mb-3"
                  style={{
                    fontSize: size ? "3rem" : "2rem",
                    fontWeight: "700",
                    letterSpacing: "0.5px",
                  }}
                >
                  PAST EVENT HIGHLIGHTS
                </h1>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                    borderRadius: "2px",
                    margin: "0 auto 2rem",
                  }}
                />
              </div>
            </Col> */}
          </Row>
          <Row className="justify-content-center">
            <Col lg={6} className="text-center mb-4">
              <Card
                style={{
                  background: "transparent",
                  borderRadius: "16px",
                  transition: "all 0.3s ease",
                }}
              >
                <img
                  src={require(`assets/images/logo/past.png`)}
                  width="100%"
                  alt="Past Event Logo"
                  style={{
                    maxWidth: size ? "400px" : "250px",
                    filter: "drop-shadow(0 8px 16px rgba(255, 180, 31, 0.3))",
                    margin: "auto",
                  }}
                />
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-center">
            {stats.map((c, i) => (
              <Col lg={3} xs={6} className="mb-4" key={i}>
                <Card
                  style={{
                    background: "rgba(255, 255, 255, 0.05)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    padding: size ? "1rem 1rem" : "1rem 1rem",
                    height: "100%",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255, 180, 31, 0.15)";
                    e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.5)";
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 10px 25px rgba(255, 180, 31, 0.3)";
                    const iconContainer = e.currentTarget.querySelector(".stats-icon-container");
                    const icon = e.currentTarget.querySelector("svg");
                    if (iconContainer) {
                      iconContainer.style.background =
                        "linear-gradient(135deg, rgba(255, 180, 31, 0.4), rgba(204, 182, 58, 0.3))";
                      iconContainer.style.borderColor = "rgba(255, 180, 31, 0.6)";
                      iconContainer.style.transform = "scale(1.1) rotate(5deg)";
                    }
                    if (icon) {
                      icon.style.color = "#ffb41f";
                      icon.style.transform = "rotate(-5deg)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    const iconContainer = e.currentTarget.querySelector(".stats-icon-container");
                    const icon = e.currentTarget.querySelector("svg");
                    if (iconContainer) {
                      iconContainer.style.background =
                        "linear-gradient(135deg, rgba(255, 180, 31, 0.2), rgba(204, 182, 58, 0.15))";
                      iconContainer.style.borderColor = "rgba(255, 180, 31, 0.3)";
                      iconContainer.style.transform = "scale(1) rotate(0deg)";
                    }
                    if (icon) {
                      icon.style.color = "#ccb63a";
                      icon.style.transform = "rotate(0deg)";
                    }
                  }}
                >
                  <div
                    className="stats-icon-container"
                    style={{
                      width: size ? "100px" : "80px",
                      height: size ? "100px" : "80px",
                      background:
                        "linear-gradient(135deg, rgba(255, 180, 31, 0.2), rgba(204, 182, 58, 0.15))",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "2px solid rgba(255, 180, 31, 0.3)",
                      boxShadow:
                        "0 4px 15px rgba(255, 180, 31, 0.2), inset 0 0 20px rgba(255, 180, 31, 0.1)",
                      transition: "all 0.3s ease",
                      transformOrigin: "center center",
                    }}
                  >
                    {React.createElement(c.icon, {
                      size: size ? 45 : 35,
                      strokeWidth: 2.5,
                      style: {
                        color: "#ccb63a",
                        filter: "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))",
                        transition: "all 0.3s ease",
                      },
                    })}
                  </div>
                  <div>
                    <h3
                      className="mb-2"
                      style={{
                        fontSize: size ? "2.5rem" : "2rem",
                        fontWeight: "700",
                        color: "#ffb41f",
                        lineHeight: "1.2",
                      }}
                    >
                      {c.value}
                    </h3>
                    <p
                      className="text-white mb-0"
                      style={{
                        fontSize: size ? "16px" : "14px",
                        fontWeight: "500",
                        lineHeight: "1.4",
                        letterSpacing: "0.3px",
                      }}
                    >
                      {c.title}
                    </p>
                  </div>
                </Card>
              </Col>
            ))}

            <Col lg={12} className="text-center px-1 mt-5">
              <Button
                href="/past-events"
                className="rounded-0 text-400 text-white"
                size="lg"
                rel="noopener noreferrer"
                style={{
                  background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                  border: "none",
                  padding: size ? "1rem 3rem" : "0.75rem 2rem",
                  fontWeight: "600",
                  fontSize: size ? "18px" : "16px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(255, 180, 31, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 8px 25px rgba(255, 180, 31, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(255, 180, 31, 0.3)";
                }}
              >
                View More
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      <div
        style={{
          background: "transparent",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
        <div className="filter" />
        <Container className={""}>
          <Row className="justify-content-center">
            <Col md="12">
              <div className="mb-5">
                <h1
                  className="text-center text-g mb-3"
                  style={{
                    fontSize: size ? "3rem" : "2rem",
                    fontWeight: "700",
                    letterSpacing: "0.5px",
                  }}
                >
                  WHO CAN PARTICIPATE
                </h1>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                    borderRadius: "2px",
                    margin: "0 auto 2rem",
                  }}
                />
              </div>
            </Col>
            {content.map((c, i) => (
              <Col lg={4} xs={6} className="mb-4" key={i}>
                <Card
                  style={{
                    background: "rgba(255, 255, 255, 0.05)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    padding: size ? "1rem" : "1rem",
                    height: "100%",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255, 180, 31, 0.15)";
                    e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.5)";
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 10px 25px rgba(255, 180, 31, 0.3)";
                    const iconContainer = e.currentTarget.querySelector(
                      ".participant-icon-container",
                    );
                    const icon = e.currentTarget.querySelector("svg");
                    if (iconContainer) {
                      iconContainer.style.background =
                        "linear-gradient(135deg, rgba(255, 180, 31, 0.4), rgba(204, 182, 58, 0.3))";
                      iconContainer.style.borderColor = "rgba(255, 180, 31, 0.6)";
                      iconContainer.style.transform = "rotate(10deg)";
                    }
                    if (icon) {
                      icon.style.color = "#ffb41f";
                      icon.style.transform = "rotate(-10deg)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    const iconContainer = e.currentTarget.querySelector(
                      ".participant-icon-container",
                    );
                    const icon = e.currentTarget.querySelector("svg");
                    if (iconContainer) {
                      iconContainer.style.background =
                        "linear-gradient(135deg, rgba(255, 180, 31, 0.2), rgba(204, 182, 58, 0.15))";
                      iconContainer.style.borderColor = "rgba(255, 180, 31, 0.3)";
                      iconContainer.style.transform = "rotate(0deg)";
                    }
                    if (icon) {
                      icon.style.color = "#ccb63a";
                      icon.style.transform = "rotate(0deg)";
                    }
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      flexDirection: size ? "row" : "column",
                      alignItems: size ? "center" : "center",
                      justifyContent: "center",
                      textAlign: size ? "left" : "center",
                    }}
                  >
                    <div
                      className="participant-icon-container"
                      style={{
                        width: size ? "70px" : "80px",
                        height: size ? "70px" : "80px",
                        minWidth: size ? "70px" : "80px",
                        background:
                          "linear-gradient(135deg, rgba(255, 180, 31, 0.2), rgba(204, 182, 58, 0.15))",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "2px solid rgba(255, 180, 31, 0.3)",
                        marginRight: size ? "1.5rem" : "0",
                        marginBottom: size ? "0" : "1rem",
                        flexShrink: 0,
                        boxShadow:
                          "0 4px 15px rgba(255, 180, 31, 0.2), inset 0 0 20px rgba(255, 180, 31, 0.1)",
                        transition: "all 0.3s ease",
                        transformOrigin: "center center",
                      }}
                    >
                      {React.createElement(c.icon, {
                        size: size ? 35 : 40,
                        strokeWidth: 2.5,
                        style: {
                          color: "#ccb63a",
                          filter: "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))",
                          transition: "all 0.3s ease",
                        },
                      })}
                    </div>
                    <div className={size ? "flex-grow-1" : ""}>
                      <p
                        className="text-white mb-0"
                        style={{
                          fontSize: size ? "15px" : "14px",
                          fontWeight: "500",
                          lineHeight: "1.4",
                          letterSpacing: "0.3px",
                        }}
                      >
                        {c.title}
                      </p>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          <Row className="justify-content-center">
            <Col lg={3} className="text-center px-1 mt-5">
              <Button
                href="/register"
                className="rounded-0 text-400 text-white"
                size="lg"
                rel="noopener noreferrer"
                style={{
                  background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                  border: "none",
                  padding: size ? "1rem 3rem" : "0.75rem 2rem",
                  fontWeight: "600",
                  fontSize: size ? "18px" : "16px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(255, 180, 31, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 8px 25px rgba(255, 180, 31, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(255, 180, 31, 0.3)";
                }}
              >
                REGISTER NOW
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

const content = [
  { title: "IT LEADERS", icon: Monitor },
  { title: "GIS LEADERS", icon: Map },
  { title: "CITY PLANNERS", icon: Building2 },
  { title: "PROJECT OWNERS", icon: Briefcase },
  { title: "PROPERTY DEVELOPERS", icon: Home },
  { title: "FACILITY MANAGERS", icon: Settings },
  { title: "DATA MANAGEMENT LEADERS", icon: Database },
  { title: "METAVERSE SOLUTION PROVIDERS", icon: Box },
  { title: "DIGITAL TWIN SOLUTION PROVIDERS", icon: Cpu },
  { title: "GOVERNMENT BODIES & MUNICIPALITIES", icon: Landmark },
  { title: "CONSTRUCTION MANAGEMENT CONSULTANTS", icon: Wrench },
  { title: "GEOSPATIAL & GIS SOLUTION PROVIDERS", icon: Navigation },
  { title: "ARCHITECTURE, ENGINEERING, CONTRACTORS FIRMS", icon: HardHat },
  { title: "BIM & DIGITAL CONSTRUCTION SOLUTION PROVIDERS", icon: Code },
];

const stats = [
  { title: "SPEAKERS", value: 35, icon: Mic },
  { title: "DELEGATES", value: 210, icon: Users },
  { title: "SPONSORS", value: 8, icon: Award },
  { title: "PARTNERS", value: 4, icon: Handshake },
];

export default Attend;
